module.exports = __webpack_public_path__ + "media/images/emblems/Matran-coat_of_arms-e7bbf85fe8e4a872ad22f8aacb579e69.svg";